import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { darfSelbstErneuern, laeuftBaldAb } from "@/lib/sitzungAblauf";

/**
 * Das angemeldete Konto aus der Sitzung im Browser (`getSession()`, keine Netzabfrage).
 *
 * Läuft das Token in weniger als 30 Sekunden ab, holt der Hook ein frisches (`refreshSession()`), damit keine Abfrage
 * mit einem abgelaufenen Token still leer bleibt. Das Token liest `src/lib/sitzungAblauf.ts` (base64url): Mit `atob()`
 * scheiterte es bei Namen wie „Großmann“, der Hook erneuerte in einer Schleife, bis Supabase mit 429 abbrach und das
 * Mitglied abgemeldet war (03.11.2026). Deshalb erneuert er nur, wenn der Ablauf sicher bekannt ist, und höchstens
 * einmal je Minute (`darfSelbstErneuern()`).
 */
export async function aktuellesKontoLaden() {
  const { data: { session } } = await supabase.auth.getSession();

  if (!session) return null;

  if (laeuftBaldAb(session) === true && darfSelbstErneuern()) {
    console.log('[useCurrentUser] Session expired/expiring, refreshing...');
    const { data: refreshData } = await supabase.auth.refreshSession();

    if (refreshData?.session) {
      return refreshData.session.user;
    }

    // Refresh failed - session is truly dead
    console.warn('[useCurrentUser] Session refresh failed, user is logged out');
    return null;
  }

  return session.user;
}

export const useCurrentUser = () => {
  return useQuery({
    queryKey: ["current-user"],
    queryFn: aktuellesKontoLaden,
    staleTime: 2 * 60 * 1000, // 2 minutes (reduced from 10 to catch expiry sooner)
    gcTime: 5 * 60 * 1000,
    retry: 1,
  });
};
